/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Untitled_SectionInputs */

const fr_untitled_section = /** @type {(inputs: Untitled_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section sans titre`)
};

/**

* @param {Untitled_SectionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const untitled_section = /** @type {((inputs?: Untitled_SectionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Untitled_SectionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_untitled_section(inputs)
});